var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.tipo_usuario !== 'usuario_externo')?_c('v-layout',[_c('finalizar-ciudadania-sin-archivo')],1):_vm._e(),_vm._v(" "),(_vm.tipo_usuario === 'usuario_externo')?_c('v-layout',[_c('finalizar-normal')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f6442be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/declaracion/finalizar.vue
// module id = qmE7
// module chunks = 1